import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import * as moment from 'moment';
import { DataServiceProvider } from '../../providers/data-service/data-service';

@Component({
  selector: 'feeding-modal',
  templateUrl: 'feeding-modal.html'
})
export class FeedingModalComponent {
  //standardType: any = "";

  user: any;
  newEntry: boolean = true;
  feeding: any;
  types: any = {};
  typesArray: any[] = [];
  maxRange: any;
  step: any;
  unit: any;
  standardType: any;

  onSelectChange(selectedValue: any) {
    this.maxRange = this.types[selectedValue].maxRange;
    this.unit = this.types[selectedValue].unit;
    if (this.feeding.amount > this.maxRange) {
      this.feeding.amount == this.maxRange;
    }
    if (this.maxRange < 100) {
      this.step = 1;
    } else {
      this.step = 5;
    }
  }

  constructor(
    public viewCtrl: ViewController,
    public toastCtrl: ToastController,
    public navParams: NavParams,
    private dataService: DataServiceProvider
  ) {
    this.types = dataService.getTypes();
    this.standardType = dataService.standardType;
    for (let type in this.types) {
      this.typesArray.push(type);
    }
    if (navParams.data.feeding) {
      this.feeding = navParams.data.feeding;
      this.newEntry = false;
      this.maxRange = this.types[this.feeding.type].maxRange;
      this.unit = this.types[this.feeding.type].unit;
    } else {
      this.maxRange = this.types[this.standardType].maxRange;
      this.unit = this.types[this.standardType].unit;
      this.feeding = {
        amount: 0,
        type: this.standardType,
        comment: '',
        timestamp: moment().format()
      };
    }
    if (this.maxRange < 100) {
      this.step = 1;
    } else {
      this.step = 5;
    }
  }

  submit() {
    this.user = this.dataService.user;
    if (this.user) {
      if (!this.newEntry) {
        this.dataService.data
          .child(this.user.uid)
          .child('feedings')
          .child(this.feeding.uid)
          .remove();
      }
      this.feeding.userId = this.user.uid;
      let key = this.dataService.data
        .child(this.user.uid)
        .child('feedings')
        .push().key;
      this.feeding.uid = key;
      this.dataService.data
        .child(this.user.uid)
        .child('feedings')
        .child(key)
        .set(this.feeding);

      let toast = this.toastCtrl.create({
        message: 'Fütterung erfolgreich gespeichert',
        duration: 3000,
        position: 'top'
      });
      toast.present().then((value: any) => {
        this.viewCtrl.dismiss();
      });
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/feeding-modal/feeding-modal.ts